"use client";

import { AdvertisingBanner } from "@aprosoja/containers";
import { Breadcrumb, Skeleton } from "@aprosoja/ui";

import useMedia from "./use-media";
import MediaGallery from "./components/media-gallery/media-gallery";

const Media = () => {
  const { photos, videos, isLoading } = useMedia();

  const segments = [{ label: "Mídia", path: "midia" }];

  return (
    <div className="max-w-[1560px] mx-auto flex flex-col w-full gap-size-x10 py-size-x14 px-size-x4 tabletMedium:px-size-x10">
      <AdvertisingBanner type="top" />
      <Breadcrumb segments={segments} />
      {isLoading ? (
        <div className="flex w-full h-[877px]">
          <Skeleton className="bg-neutral-300 w-full h-full" />
        </div>
      ) : (
        <MediaGallery photos={photos} videos={videos} />
      )}
    </div>
  );
};

export default Media;
